import { MapMarkerWithPopup, useTheme } from "@shared/primitive-components"
import { FeatureGroup, Polyline, TileLayer, Tooltip, useMap } from "react-leaflet"
import { Theme } from "../theme/theme.types"
import { Position, type Feature, type GeoJson, type LineString, type LineStringFeatureProperties } from "./types"
import { isSpeedUnreliable, swapLatLng } from "./utils"

type Marker = {
  position: Position
  content: string
}

type Props = {
  generateTooltipContentFn: (
    geoJsonFeature: Feature<LineString, LineStringFeatureProperties>,
    hasUnreliableSpeed: boolean
  ) => JSX.Element
  apiKey: string
  markers: Marker[]
  route: GeoJson
  styleFn: (geoJsonFeature: Feature<LineString, LineStringFeatureProperties>, theme: Theme) => string
}

export const MapContent = ({ apiKey, generateTooltipContentFn, markers, route, styleFn }: Props) => {
  const theme = useTheme()
  const map = useMap()
  map.attributionControl.setPrefix(false)
  map.setMaxBounds(map.getBounds())
  map.setMinZoom(map.getZoom())

  const here = { apiKey }
  const hereTileUrl = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=lite.night&apiKey=${here.apiKey}`
  const attribution = `&copy; HERE 2022`

  return (
    <>
      <TileLayer url={hereTileUrl} attribution={attribution} />
      {route.lineStrings.map((feature, i) => (
        // Duplicates on the geojson features makes mandatory to use the index as a key
        // eslint-disable-next-line react/no-array-index-key
        <FeatureGroup key={i}>
          <Tooltip sticky>{generateTooltipContentFn(feature, isSpeedUnreliable(feature))}</Tooltip>
          <Polyline
            color={styleFn(feature, theme)}
            weight={5}
            positions={feature.geometry.coordinates.map((coord) => swapLatLng(coord))}
          />
        </FeatureGroup>
      ))}
      {markers.map(({ position, content }) => (
        <MapMarkerWithPopup key={`${position[0]}-${position[1]}`} position={swapLatLng(position)} content={content} />
      ))}
    </>
  )
}
